module.exports = __webpack_public_path__ + "Participant Notice 06_17_2024.pdf";